module.exports = __webpack_public_path__ + "static/media/glowfinal.a908d114.jpg";